import { NavLink, Outlet } from 'react-router';
import { ClipboardListIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';

import { PageHeader } from '@/components/layout/page-header';
import { cn } from '@/lib/utils';

const sections = [
  { title: 'Users', to: '/admin/users', icon: UsersIcon },
  { title: 'Audit log', to: '/admin/audit-log', icon: ClipboardListIcon }
];

/** Shared navigation for platform-wide super-admin capabilities. */
export function AdminLayout() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Administration"
        description="Platform-wide member management and audit history."
        icon={ShieldCheckIcon}
      />
      <nav aria-label="Administration sections" className="border-border flex gap-1 border-b">
        {sections.map((section) => {
          const Icon = section.icon;

          return (
            <NavLink
              key={section.to}
              to={section.to}
              className={({ isActive }) =>
                cn(
                  'focus-visible:ring-ring -mb-px inline-flex items-center gap-2 border-b-2 px-3 py-2 text-sm transition-colors focus-visible:ring-2 focus-visible:outline-none motion-reduce:transition-none',
                  isActive
                    ? 'border-foreground text-foreground font-medium'
                    : 'text-muted-foreground hover:text-foreground border-transparent'
                )
              }
            >
              <Icon className="size-4" />
              {section.title}
            </NavLink>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
